var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.976 20.536a.75.75 0 101.048-1.072l-1.048 1.072zm-2.857-4.889a.75.75 0 00-1.049 1.073l1.049-1.072zm-9.063-5.286a.75.75 0 000 1.5v-1.5zm7.11 1.5a.75.75 0 000-1.5v1.5zm-4.305 2.806a.75.75 0 001.5 0h-1.5zm1.5-7.111a.75.75 0 00-1.5 0h1.5zm5.611 3.555a6.361 6.361 0 01-6.36 6.361v1.5a7.861 7.861 0 007.86-7.86h-1.5zm-6.36 6.361a6.361 6.361 0 01-6.362-6.36h-1.5a7.861 7.861 0 007.861 7.86v-1.5zm-6.362-6.36a6.361 6.361 0 016.361-6.362v-1.5a7.861 7.861 0 00-7.861 7.861h1.5zm6.361-6.362a6.361 6.361 0 016.361 6.361h1.5a7.861 7.861 0 00-7.86-7.861v1.5zm9.413 14.714l-3.905-3.816-1.049 1.072 3.906 3.816 1.048-1.072zM8.056 11.86h3.555v-1.5H8.056v1.5zm3.555 0h3.556v-1.5H11.61v1.5zm.75 2.806V11.11h-1.5v3.556h1.5zm0-3.556V7.556h-1.5v3.555h1.5z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomPlus);
export default __webpack_public_path__ + "static/media/zoom_plus.eefe7da31f371f03a774ce40d0e3c5a2.svg";
export { ForwardRef as ReactComponent };